<template>
  <div class="light-secondary-section border-round-2xl">
    <div class="flex flex-column">
      <Filters ref="filtersRef" :filtros="filtros" :section="'Left'" />

      <!-- Filters action section -->
      <div 
        v-if="topSectionFiltersLength == 0
        || (isMobile && topSectionFiltersLength > 0)" class="grid m-0">
        <div class="col-12 flex flex-column gap-2">
          <Button
            v-if="filtros.length"
            size="small"
            class="w-full apply-filter mt-2"
            :label="topSectionFiltersLength > 0 ? 'Aplicar todos los filtros' : 'Aplicar filtros'"
            @click="emit('apply-filters')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import Button from "primevue/button";

import Filters from "@/pages/_root/views/reports-details/sections/Filters.vue";

// #region Props, Emits
const props = defineProps({
  filtros: {
    type: Array,
    required: true,
  },
  topSectionFiltersLength: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["apply-filters"]);
// #endregion

// #region  Params, Ref, Reactives, Computed
const filtersRef = ref(null);
const isMobile = ref(window.innerWidth <= 575);

function updateIsMobile() {
  isMobile.value = window.innerWidth <= 575;
}
// #endregion

// #region Functions
function getFilters() {
  const values = filtersRef.value.values;
  const ranges = filtersRef.value.ranges;

  return {
    filters: props.filtros,
    values,
    ranges,
  };
}
// #endregion

// #region Effects, Hooks
onMounted(() => {
  window.addEventListener('resize', updateIsMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateIsMobile);
});
// #endregion

// #region Provide, Expose
defineExpose({
  getFilters,
});
// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";
.apply-filter {
  background-color: $primary;
}
</style>
